
import { IAuthProvider } from "./IAuthProvider";
import { AppDispatch } from "../../configureStore";

export class KeycloakAuthProvider implements IAuthProvider {

    private getCfg() {
        return {
            keycloakUrl: (window._env_.REACT_APP_KEYCLOAK_URL || process.env.REACT_APP_KEYCLOAK_URL || "").replace(/\/+$/, ""), // Remove trailing slash if exists
            realm: (window._env_.REACT_APP_KEYCLOAK_REALM || process.env.REACT_APP_KEYCLOAK_REALM || ""),
            clientId: (window._env_.REACT_APP_KEYCLOAK_CLIENT_ID || process.env.REACT_APP_KEYCLOAK_CLIENT_ID || ""),
            apiBaseUrl: (window._env_.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_BASE_URL || "").replace(/\/+$/, ""),
        };
    }

    async login(prompt?: string): Promise<void> {
        console.log("Keycloak login() -> redirect");
        const cfg = this.getCfg();
        const returnUrl = encodeURIComponent(window.location.href);
        const promptParam = prompt ? `&prompt=${encodeURIComponent(prompt)}` : "";
        window.location.href = `${cfg.apiBaseUrl}/KeycloakAuth/keycloak-login?returnUrl=${returnUrl}${promptParam}`;
    }

    async logout(keyCloakIdToken?: string | null): Promise<void> {
        console.log("Keycloak logout()");
        sessionStorage.clear();
        localStorage.clear();

        window.location.href = this.buildKeycloakLogoutUrl(keyCloakIdToken);
    }

    private buildKeycloakLogoutUrl(idToken?: string | null): string {
        const cfg = this.getCfg();
        const redirectUri = encodeURIComponent(window.location.origin);

        let url = `${cfg.keycloakUrl}/realms/${cfg.realm}/protocol/openid-connect/logout`
                + `?client_id=${encodeURIComponent(cfg.clientId)}`
                + `&post_logout_redirect_uri=${redirectUri}`;
        if (idToken) url += `&id_token_hint=${encodeURIComponent(idToken)}`;
        return url;
    }

    getToken(): string | null {
        // return sessionStorage.getItem("accessToken");
        return sessionStorage.getItem("authCode");
    }

    async handleRedirect(dispatch: AppDispatch, externalSignIn: (token: string, useCache?: boolean) => any): Promise<void> {

        console.log("Keycloak redirect handled, user authenticated");
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get("code"); 
        const error = urlParams.get("error");

        window.history.replaceState({}, document.title, window.location.pathname);

        if (error) {
            return;
        }

        if (!code) {
            return;
        }
        sessionStorage.setItem("authCode", code);

        try {
            const response: any = await dispatch(externalSignIn(code,true));

            const status = response?.status ?? response?.response?.status;
            if (status === 200) {
                // success path - consume token, log user in
                sessionStorage.removeItem("authCode");
                return;
            }

            // failure path: tear down keycloak session.
            const idToken = 
                response?.data?.id_token ??
                response?.response?.data?.extensions?.id_token ??
                response?.response?.data?.id_token ??
                null;

            sessionStorage.removeItem("authCode");
            window.location.href = this.buildKeycloakLogoutUrl(idToken);
        } catch (err: any) {
            console.error("externalSignIn threw: ", err);
            sessionStorage.removeItem("authCode");
            window.location.href = this.buildKeycloakLogoutUrl(null);
        }
    }

    async refreshToken(): Promise<string | null> {
        const baseUrl = (window._env_.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_BASE_URL) ?? "";
        const urlWithoutSlash = baseUrl.replace(/\/+$/, "");

        try {
            const response = await fetch(`${urlWithoutSlash}/KeycloakAuth/refresh-token`, {
                method: 'POST',
                credentials: 'include' // Include cookies if using cookie-based session
            });

            if (response.ok) {
                const data = await response.json();
                sessionStorage.setItem("accessToken", data.token);
                return data.token;
            }
            return null;
        } catch (error) {
            console.error("Token refresh failed:", error);
            return null;
        }
    }
}
